// Single entry point the rest of the app imports.
//
// Switching between mock and real API:
//   * VITE_USE_MOCK_API=true   → mock data, no network. Default for dev.
//   * VITE_USE_MOCK_API=false  → real /api/* endpoints with mock fallback
//     for surfaces the backend can't serve (templates, playbooks).
//
// The real adapter falls back to mock seed data when the backend returns
// 401/403, so the prototype's no-auth promise is preserved even on a
// fresh dev environment without an org connection.

import { mockApi } from "@/lib/api/mock";
import { realApi } from "@/lib/api/real";

// Default is REAL backend. Set VITE_USE_MOCK_API=true for offline /
// design-review work where you want seeded fixtures instead of live
// /api/* calls.
export const USE_MOCK =
  (import.meta.env.VITE_USE_MOCK_API ?? "false").toString().toLowerCase() === "true";

export const api = USE_MOCK ? mockApi : realApi;

export type Api = typeof api;
